import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n  color: ",
        ";\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px; /* 150% */\n  letter-spacing: -0.16px;\n\n  span {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  height: 100%;\n  flex-direction: column;\n  gap: 12px;\n\n  overflow-y: auto;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n\n  flex-direction: column;\n  gap: 12px;\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 16px;\n\n  padding: 16px 28px 28px 28px;\n  background-color: ",
        ";\n\n  @media (max-width: 768px) {\n    padding: 16px;\n\n    button {\n      width: 100%;\n    }\n  }\n\n  button {\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px; /* 150% */\n    letter-spacing: -0.16px;\n    padding: 12px 20px;\n  }\n"
    ]);
    _templateObject5 = function() {
        return data;
    };
    return data;
}
function _templateObject6() {
    const data = _tagged_template_literal([
        "\n  height: 100%;\n  max-height: calc(100vh - 224px);\n  overflow-y: auto;\n\n  @media (max-width: 768px) {\n    margin-top: 28px;\n  }\n"
    ]);
    _templateObject6 = function() {
        return data;
    };
    return data;
}
function _templateObject7() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: end;\n  align-items: center;\n  margin-top: 28px;\n\n  @media (max-width: 768px) {\n    button {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject7 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import { Button, ConfirmDialog } from "@bookips/solvook-ui-library";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { postUserCoupon } from "src/api/coupon";
import { formatDateToDot } from "src/utils/formatting";
import styled from "styled-components";
import FilledButton from "../common/Button/FilledButton";
import AnchorDrawer from "../modal/AnchorDrawer";
import Coupon from "./Coupon";
import SimpleDialog from "./SimpleDialog";
const CouponContents = (param)=>{
    let { handoutCoupons  } = param;
    //자 여기에서 실행하면 안될것 같지만 일단 기능부터
    const queryClient = useQueryClient();
    const postGetCouponMutation = useMutation(postUserCoupon);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const onGetCouponClick = useCallback(async (id, name)=>{
        try {
            const response = await postGetCouponMutation.mutateAsync(id);
            queryClient.invalidateQueries([
                "getHandoutCoupons"
            ]);
            //mx
            mixpanelEvent("Coupon Issued", {
                "Coupon ID": id,
                "Coupon Name": name
            });
            if (response.status === 404) {
                // Coupon not found
                setDialogOpen(true);
                setErrorMessage("쿠폰 정보가 존재하지 않아요.");
            }
            if (response.status === 409) {
                // Already received
                setDialogOpen(true);
                setErrorMessage("이미 발급된 쿠폰이예요.");
            }
        } catch (error) {
            const { status  } = error.response;
            if (status === 404) {
                // Coupon not found
                setDialogOpen(true);
                setErrorMessage("쿠폰 정보가 존재하지 않아요.");
            }
            if (status === 409) {
                // Already received
                setDialogOpen(true);
                setErrorMessage("이미 발급된 쿠폰이예요.");
            }
        }
    }, [
        postGetCouponMutation
    ]);
    return /*#__PURE__*/ _jsxs(CouponContainer, {
        children: [
            errorMessage && /*#__PURE__*/ _jsx(ConfirmDialog, {
                open: dialogOpen,
                severity: "caution",
                onClose: ()=>setDialogOpen(false),
                title: errorMessage,
                footer: /*#__PURE__*/ _jsx(ButtonOneBox, {
                    children: /*#__PURE__*/ _jsx(Button, {
                        label: "확인",
                        variant: "solid",
                        onClick: ()=>setDialogOpen(false)
                    })
                })
            }),
            /*#__PURE__*/ _jsxs(CouponCount, {
                children: [
                    "상품쿠폰 ",
                    /*#__PURE__*/ _jsxs("span", {
                        children: [
                            handoutCoupons.length,
                            "장"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CouponList, {
                children: handoutCoupons.map((coupon, index)=>{
                    /*#__PURE__*/ return _jsxs(Coupon, {
                        children: [
                            /*#__PURE__*/ _jsxs(Coupon.Content, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        children: [
                                            /*#__PURE__*/ _jsx(Coupon.Title, {
                                                children: coupon.name
                                            }),
                                            /*#__PURE__*/ _jsx(Coupon.MaxDiscount, {
                                                children: "최대 ".concat(numberFormatter(coupon.discountMaximumPrice), "원 할인")
                                            }),
                                            (coupon === null || coupon === void 0 ? void 0 : coupon.minimumPrice) && /*#__PURE__*/ _jsxs(Coupon.Condition, {
                                                children: [
                                                    numberFormatter(coupon.minimumPrice),
                                                    "원 이상 자료에 사용가능"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Coupon.ExpireDate, {
                                        children: coupon.expiredAfterDay ? "받기 후 ".concat(coupon.expiredAfterDay, "일간 사용 가능") : coupon.expiredAt && formatDateToDot(coupon.expiredAt) + "까지"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Coupon.Possession, {
                                status: coupon.hasBeenReceived,
                                onHandleClick: ()=>{
                                    if (coupon.hasBeenReceived === false) onGetCouponClick(coupon.id, coupon.name);
                                }
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
export const AdditionalCouponDialog = (param)=>{
    let { open , handleClose , handoutCoupons  } = param;
    return /*#__PURE__*/ _jsx(SimpleDialog, {
        open: open,
        onClose: ()=>handleClose(),
        title: "할인쿠폰 받기",
        subParagraph: "해당 상품에 적용가능한 쿠폰만 표시돼요.",
        scroll: "paper",
        footer: /*#__PURE__*/ _jsx(ButtonBox, {
            children: /*#__PURE__*/ _jsx(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>handleClose(),
                children: "확인"
            })
        }),
        children: /*#__PURE__*/ _jsx(DialogContents, {
            children: /*#__PURE__*/ _jsx(CouponContents, {
                handoutCoupons: handoutCoupons
            })
        })
    });
};
export const AdditionalCouponDrawer = (param)=>{
    let { open , anchor , handleClose , handoutCoupons  } = param;
    return /*#__PURE__*/ _jsxs(AnchorDrawer, {
        anchor: anchor !== null && anchor !== void 0 ? anchor : "bottom",
        open: open,
        onClose: ()=>handleClose(),
        title: "할인쿠폰 받기",
        children: [
            /*#__PURE__*/ _jsxs(AnchorDrawer.Contents, {
                children: [
                    /*#__PURE__*/ _jsx(AnchorDrawer.Title, {
                        children: "할인쿠폰 받기"
                    }),
                    /*#__PURE__*/ _jsx(ExplainText, {
                        children: "해당 상품에 적용가능한 쿠폰만 표시돼요."
                    }),
                    /*#__PURE__*/ _jsx(ScrollBody, {
                        children: /*#__PURE__*/ _jsx(CouponContents, {
                            handoutCoupons: handoutCoupons
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ButtonBox, {
                children: /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: "solid",
                    onClick: ()=>handleClose(),
                    children: "확인"
                })
            })
        ]
    });
};
export const ExplainText = styled.p.withConfig({
    componentId: "sc-9034f572-0"
})(_templateObject(), (props)=>props.theme.new.colors.sol_gray_700);
const CouponCount = styled.p.withConfig({
    componentId: "sc-9034f572-1"
})(_templateObject1(), (props)=>props.theme.new.colors.sol_blue_500);
const DialogContents = styled.div.withConfig({
    componentId: "sc-9034f572-2"
})(_templateObject2());
const CouponContainer = styled.div.withConfig({
    componentId: "sc-9034f572-3"
})(_templateObject3());
const CouponList = styled.ul.withConfig({
    componentId: "sc-9034f572-4"
})(_templateObject4());
const ButtonBox = styled.div.withConfig({
    componentId: "sc-9034f572-5"
})(_templateObject5(), (props)=>props.theme.new.colors.sol_dim_white_90);
export const ScrollBody = styled.div.withConfig({
    componentId: "sc-9034f572-6"
})(_templateObject6());
const ButtonOneBox = styled.div.withConfig({
    componentId: "sc-9034f572-7"
})(_templateObject7());
